import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CmsLinkComponent } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';

@Component({
    selector: 'app-privacy-policy-section3-buttons',
    templateUrl: './privacy-policy-section3-buttons.component.html',
    styleUrl: './privacy-policy-section3-buttons.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class PrivacyPolicySection3ButtonsComponent {
  public componentData: CmsLinkComponent;


  constructor(public component: CmsComponentData<CmsLinkComponent>) { }


  ngOnInit(): void{
    this.component.data$.subscribe((data) => {
          this.componentData = data;
        });
      }
}
